import NormasVacaciones from './normas-vacaciones.vue';
import RoutesUtils from '../../js/RoutesUtils.js';

// Ajustes · Normas de vacaciones (#56). El acceso de verdad lo pone el backend (403 a quien no
// sea ADMIN o DIRECTOR al publicar y al ver el historial) y la entrada del menú;
// checkPermission es lo que evita entrar por URL a una pantalla que no se puede usar.
//
// La lectura de la versión vigente sí es de cualquier usuario autenticado, pero esta pantalla no
// es para leerlas: eso lo hará la ventana de solicitud de #58, que no cuelga de esta ruta.
const routes = [
    {
        path: '/normasvacaciones/',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: RoutesUtils.checkPermission('normasvacaciones', ['ADMIN', 'DIRECTOR'], NormasVacaciones),
        keepAlive: true
    }
];
export default routes;
